import { useSelector } from "react-redux";

import { Delete } from "@mui/icons-material";
import { Box } from "@mui/material";
import { IconButton } from "@mui/material";

import { LineTableCell } from "components/formFields/LineTableCell";

export function DeleteLine(props) {
  const { onClick } = props;
  const linesLoading = useSelector((state) => state.loading.linesLoading);
  return (
    <LineTableCell sx={{ displayPrint: "none" }}>
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <IconButton size="small" onClick={onClick} disabled={linesLoading}>
          <Delete color="icons" />
        </IconButton>
      </Box>
    </LineTableCell>
  );
}
